import React, { useState, useEffect } from "react";
import SlideOverlay from "./SlideOverlay";
import CssDissolveTransition from "../CssDissolveTransition";

const SlideOperations = React.memo(function SlideOperations() {
  const [showDisplacement, setShowDisplacement] = useState(false);
  const [displaceCompleted, setDisplaceCompleted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDisplacement(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleDisplacementComplete = () => {
    setShowDisplacement(false);
    setDisplaceCompleted(true);
  };

  const getBackgroundImage = () => {
    return displaceCompleted ? "./carousel_img/operationsbg2.webp" : "./carousel_img/operationsbg.webp";
  };

  return (
    <>
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
        style={{
          backgroundImage: `url(${getBackgroundImage()})`,
          backgroundColor: "#1e1e21",
          willChange: "transform",
          contain: "layout style paint",
        }}
      >
        <img
          src={getBackgroundImage()}
          alt=""
          className="hidden"
          loading="lazy"
          decoding="async"
        />

        {showDisplacement && !displaceCompleted && (
          <CssDissolveTransition
            currentImage="./carousel_img/operationsbg.webp"
            nextImage="./carousel_img/operationsbg2.webp"
            isActive={true}
            onComplete={handleDisplacementComplete}
          />
        )}
        <div className="absolute inset-0" />
      </div>

      <SlideOverlay
        label="AI-Powered Enterprise Solutions"
        title="Intelligent Operations"
        description="No freeze — Streamline operations with our modular AI platform featuring advanced analytics, predictive insights, and automated workflow optimization"
        ctaText="See Enterprise Solutions"
        ctaUrl="/deployment/on-premise"
      />
    </>
  );
});

export default SlideOperations;

